import { faClose, faMinus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Dispatch, ReactNode, SetStateAction } from "react";
import { Col, Row } from "react-styled-flexboxgrid";
import styled from "styled-components";
import { Color } from "../theme/Color";
import SlideInHeader from "./SlideInHeader";

type Props = {
  visible: boolean;
  setVisible: Dispatch<SetStateAction<boolean>>;
  direction?: "fromTop" | "fromRight" | "fromBottom";
  children: ReactNode;
  hasPadding?: boolean;
  showCloseButton?: boolean;
  title?: String;
};

const StyledOverlay = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background: ${Color.BlackShadow2};
  transition: all 0.2s linear;

  z-index: 9999;

  &.hide {
    visibility: hidden;
    opacity: 0;
  }

  &.show {
    visibility: visible;
    opacity: 1;
  }
`;

const StyledContainer = styled.div<{
  direction: string;
  hasPadding: boolean;
}>`
  position: absolute;
  transition: all 0.45s linear;
  background: ${Color.White};
  z-index: 99999;

  ${({ direction, hasPadding }) => handleDirection(direction, hasPadding)};

  ${({ direction }) => handleBorderRadius(direction)};

  &.hide {
    position: fixed;
    visibility: hidden;
    top: ${({ direction }) => (direction === "fromTop" ? "-100%" : "")};
    right: ${({ direction }) => (direction === "fromRight" ? "-100%" : "")};
    bottom: ${({ direction }) => (direction === "fromBottom" ? "-100%" : "")};
  }

  &.show {
    position: fixed;
    visibility: visible;
    top: ${({ direction }) =>
      direction === "fromTop" ? "0px !important" : ""};
    bottom: ${({ direction }) =>
      direction === "fromBottom" ? "0px !important" : ""};
    right: ${({ direction }) =>
      direction === "fromTop" ? "0px !important" : ""};
  }

  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* Internet Explorer 10+ */

  &::-webkit-scrollbar {
    /* WebKit */
    width: 0;
    height: 0;
  }
`;

export const handleDirection = (direction, hasPadding) => {
  switch (direction) {
    case "default":
    case "fromTop":
    case "fromBottom":
      return `
          left: 0;
          width: 100%;;
          min-height: 20rem;
          @media(min-width: 500px){
            left: calc(50% - 212px);
            width: 414px;
          }
  `;
    case "fromRight":
      return `
          right: 0;
          top: 0;
          width: 80%;
          max-width: 400px;
          padding: ${({ hasPadding }) => (hasPadding ? "1rem 0" : "9rem 0")}
          height: 100vh;
      `;
  }
};

export const handleBorderRadius = (direction) => {
  switch (direction) {
    case "fromBottom":
    case "default":
      return `
        max-height: 75vh;
        overflow-y: scroll;
        overflow-x: hidden;
        -webkit-border-top-left-radius: 1rem;
        -webkit-border-top-right-radius: 1rem;
        -moz-border-radius-topleft: 1rem;
        -moz-border-radius-topright: 1rem;
        border-top-left-radius: 1rem;
        border-top-right-radius: 1rem;
      `;
    case "fromTop":
      return `
        max-height: 95vh;
        overflow-y: scroll;
        overflow-x: hidden;
        -webkit-border-bottom-left-radius: 1rem;
        -webkit-border-bottom-right-radius: 1rem;
        -moz-border-radius-bottomleft: 1rem;
        -moz-border-radius-bottomright: 1rem;
        border-bottom-left-radius: 1rem;
        border-bottom-right-radius: 1rem;
      `;
  }
};

const SlideIn = ({
  visible,
  setVisible,
  direction = "fromBottom",
  children,
  hasPadding = true,
  showCloseButton = false,
  title,
  ...props
}: Props) => {
  return (
    <>
      <StyledOverlay
        className={visible ? "show" : "hide"}
        onClick={() => {
          setVisible(false);
        }}
      />
      <StyledContainer
        direction={direction}
        className={visible ? "show" : "hide"}
        hasPadding={hasPadding}
        {...props}
      >
        {direction === "fromBottom" ? (
          <Row
            end="xs"
            onClick={() => {
              setVisible(false);
            }}
          >
            <FontAwesomeIcon
              icon={faClose}
              size="lg"
              data-cy="close-icon"
              style={{ margin: "1rem" }}
            />
          </Row>
        ) : null}
        {direction === "fromRight" && (
          <SlideInHeader
            setVisible={setVisible}
            title={title ? title : "Menu"}
          />
        )}
        <Row center="xs">
          <Col xs={12}>{children}</Col>
        </Row>
        {direction === "fromTop" ? (
          <Row
            center="xs"
            onClick={() => {
              setVisible(false);
            }}
          >
            <FontAwesomeIcon
              icon={faMinus}
              size="lg"
              data-cy="close-icon"
              color={Color.Grey2}
            />
          </Row>
        ) : null}
      </StyledContainer>
    </>
  );
};

export default SlideIn;
